import React from "react";
import {TableWrapper} from "../../styles/globalStyles";
import {ROUTES} from "../../utils/RouteConstants";
import {useHistory} from "react-router-dom";
import FetchState from "../../api/FetchState";
import LoadingIcon from "../../shared/LoadingIcon";
import NotesTable from "./NotesTable";
import {useFetchMembersNotes} from "./hooks";
import {ErrorPage} from "../../shared/ErrorPage";
import { NarrowButton } from "../../styles/globalStyles";

let noteTableHeaders = {
    columns: [
        { title: "Note", field: "note" },
    ],
}

export default function MemberFormNotesTable ({member}) {

    let history = useHistory();
    const [notes, fetchState] = useFetchMembersNotes();

    if (FetchState.SUCCESS === fetchState)
        return (
            <TableWrapper>
                <NotesTable
                    last = {ROUTES.MEMBERS_FORM}
                    tableData = {notes}
                    tableHeaders = {noteTableHeaders}
                    member = {member}
                />
                <div role="row-sections">
                    <NarrowButton type="button"
                            onClick= {() =>
                                history.push(ROUTES.NOTES_FORM, { note: notes, member: member, last: ROUTES.MEMBERS_FORM})}
                    >
                        Add New
                    </NarrowButton>

                </div>
            </TableWrapper>
    )
    else if (FetchState.ERROR === fetchState) return <ErrorPage />
    else if (FetchState.LOADING === fetchState) return <LoadingIcon />
}